/**
 * The resource processor's contract: what a caller configures, what it gets
 * back, and the cache bound both sides assume. The two-mode overview lives in
 * `createResourceProcessor.ts`.
 */
/**
 * Default per-type cache bound, several times the external resources of the
 * largest vendored scene, so it holds any scene's working set. A resource a
 * mounted consumer holds is never capacity-evicted: see `pin`.
 */
export const DEFAULT_MAX_ENTRIES = 200;
/** A failed load in a processor's cache. It keeps the reason, so a repeat request reports it. */
export class CachedFailure {
    error;
    constructor(error) {
        this.error = error;
    }
}
//# sourceMappingURL=resourceProcessorTypes.js.map